module.exports = __webpack_public_path__ + "static/media/phantom_lancer.b7186e26.png";